import { render, staticRenderFns } from "./nominacolorBoolTag.vue?vue&type=template&id=1f6844ac&functional=true&"
import script from "./nominacolorBoolTag.vue?vue&type=script&lang=js&"
export * from "./nominacolorBoolTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports